import clsx from 'clsx'
import React from 'react'
import {useLocation} from 'react-router'
import {Link} from 'react-router-dom'
import {useMasterLayout} from 'src/app/context/MasterContext'
import {checkIsActive} from 'src/app/utils/router-helpers-utils'
import {KTSVG} from '../../Libs/Icon/KTSVG'
import BulletItem from './BulletItem'
import DisabledMenu from './DisabledMenu'

type Props = {
  children?: React.ReactNode
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  activePath?: string
  badge?: string
  badgeCircle?: boolean
  disabled?: boolean
}

const AsideMenuItem: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  activePath,
  badge,
  badgeCircle,
  disabled = false,
}) => {
  const {pathname} = useLocation()
  let isActive = false

  if (activePath?.includes(',')) {
    const paths = activePath.split(',')
    isActive = paths.some((path) => checkIsActive(pathname, path))
  } else {
    isActive = checkIsActive(pathname, activePath ?? to)
  }
  const {minimize} = useMasterLayout()

  return (
    <div className='relative block p-0 text-fs-9'>
      {disabled && <DisabledMenu />}
      <Link
        className={clsx(
          'p-3 mx-3 cursor-pointer flex flex-nowrap items-center rounded-lg transition duration-100',
          'hover:text-gray-500',
          {'bg-[#F5FAFF] text-primary dark:bg-inverse-primary-light-3 dark:text-white': isActive},
          {'text-neutral-50': !isActive},
          {truncate: minimize}
        )}
        to={to}
      >
        {hasBullet && <div className='mr-5'></div>}
        {icon && (
          <span className='flex items-center w-8 mr-2 shrink-0'>
            <KTSVG path={icon} className='w-6 h-6' />
          </span>
        )}
        {/* still bootstrap style / change it !  */}
        {fontIcon && <i className={clsx('bi fs-3', fontIcon)}></i>}

        <span
          className={clsx(
            'flex items-center flex-1 transition duration-300 max-w-[150px] break-words',
            {
              'opacity-0 group-hover:opacity-100': minimize,
            }
          )}
        >
          {title}
        </span>

        {/* still bootstrap style / change it !  */}
        {badge ? (
          <span
            className={clsx('badge badge-light-secondary', {'badge-circle': badgeCircle})}
            style={{minWidth: 23, minHeight: 23}}
          >
            {badge}
          </span>
        ) : null}
      </Link>
      {children}
    </div>
  )
}

export {AsideMenuItem}
